import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { Button } from '../components/ui/button';
export function Login() {
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/select-client');
  };
  return <div className="min-h-screen flex items-center justify-center p-4 bg-[#010827]" data-id="element-883">
      <div className="bg-card w-full max-w-md rounded-lg shadow-xl p-8 md:p-10" data-id="element-884">
        <div className="text-center mb-8" data-id="element-885">
          <div className="flex flex-col leading-tight justify-center items-center mb-2" data-id="element-886">
            <span className="font-logo text-[32px] tracking-wide" style={{
            color: '#0187c3'
          }} data-id="element-887">
              Esclapon
            </span>
            <span className="font-logo text-[32px] tracking-wide" style={{
            color: '#0187c3'
          }} data-id="element-888">
              & Co.
            </span>
          </div>
          <p className="text-muted-foreground" data-id="element-889">Accedi alla piattaforma</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-5" data-id="element-890">
          <div className="space-y-2" data-id="element-891">
            <label htmlFor="email" className="text-sm font-medium text-foreground" data-id="element-892">
              Email
            </label>
            <input id="email" type="email" placeholder="nome@esclapon.it" className="w-full px-4 py-2.5 rounded-md border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-accent/50 transition-shadow" required data-id="element-893" />
          </div>

          <div className="space-y-2" data-id="element-894">
            <label htmlFor="password" className="text-sm font-medium text-foreground" data-id="element-895">
              Password
            </label>
            <input id="password" type="password" placeholder="••••••••" className="w-full px-4 py-2.5 rounded-md border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-accent/50 transition-shadow" required data-id="element-896" />
          </div>

          <Button type="submit" className="w-full rounded-full h-11 text-base" data-id="element-897">
            Accedi
          </Button>
        </form>

        <div className="my-6 flex items-center" data-id="element-898">
          <div className="flex-1 border-t border-border" data-id="element-899"></div>
          <span className="px-4 text-sm text-muted-foreground" data-id="element-900">oppure</span>
          <div className="flex-1 border-t border-border" data-id="element-901"></div>
        </div>

        <Button variant="outline" type="button" onClick={() => navigate('/select-client')} className="w-full rounded-full h-11 text-base border-border hover:bg-muted/50" data-id="element-902">
          <Shield className="h-4 w-4 mr-2" data-id="element-903" />
          Accedi con SSO aziendale
        </Button>

        <div className="mt-8 text-center" data-id="element-904">
          <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-id="element-905">
            Problemi di accesso? Contatta il supporto
          </a>
        </div>
      </div>
    </div>;
}